/**
 * Vendor → workers drill-down sub-page (/manpower/vendors/:vendorId/workers).
 * Thin wrapper: reuses the Workers listing locked to one vendor — back header,
 * vendor-named title, no vendor filter, and Add Worker pre-locked to this vendor.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { WorkerListing } from '../../manpower-workers/components/WorkerListing';

export const VendorWorkers: React.FC = () => {
	const { vendorId } = useParams<{ vendorId: string }>();
	return (
		<WorkerListing
			lockedVendorId={Number(vendorId)}
			backTo={{ label: 'Vendors', href: '/manpower/vendors' }}
		/>
	);
};

export default VendorWorkers;
